(function () {
  'use strict';

  function openPanel(btn) {
    var id = btn.getAttribute('aria-controls');
    var panel = id ? document.getElementById(id) : null;
    btn.setAttribute('aria-expanded', 'true');
    if (panel) panel.setAttribute('aria-hidden', 'false');
  }

  function closePanel(btn) {
    var id = btn.getAttribute('aria-controls');
    var panel = id ? document.getElementById(id) : null;
    btn.setAttribute('aria-expanded', 'false');
    if (panel) panel.setAttribute('aria-hidden', 'true');
  }

  function toggle(btn) {
    if (btn.getAttribute('aria-expanded') === 'true') {
      closePanel(btn);
    } else {
      openPanel(btn);
    }
  }

  function init(root) {
    root.querySelectorAll('[data-lcu-accordion]').forEach(function (btn) {
      if (btn.dataset.lcuInit) return;
      btn.dataset.lcuInit = '1';
      btn.addEventListener('click', function () { toggle(btn); });
      btn.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          toggle(btn);
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
